
export enum MeetingFlags {
  Priority = "Priority",
  Optional = "Optional"
}

export enum MeetingStatus {
  Accepted = "Accepted",
  Declined = "Declined",
  Tentative = "Tentative",
  NeedsAction = "NeedsAction"
}

export enum MeetingTags {
  P2P = "P2P",
  Company = "Company",
  People = "People",
}

export type EventData = {
  title: string,
  description?: string;
  status: MeetingStatus;
  attendees: any;
  meetingLink: string;
  location?: string;
  flag?: MeetingFlags;
  tags?: MeetingTags[];
  isAccepted?: boolean;
  meetingDomain: string
};

export type EventItem = {
  id: number;
  recurringEventId: string | null;
  organizer: string;
  start: Date;
  end: Date;
  data?: EventData;
};

export enum EventColorCode {
  BASE = "BASE",
  // PRIORITY = "PRIORITY",
  // BASE_BORDER = "BASE_BORDER",
  // PRIORITY_BORDER = "PRIORITY_BORDER",
}

export const EVENT_COLORS = {
  BASE: "#F5F9FF",
  BASE_BORDER: "#BFDAFF",
  // PRIORITY: "#FFF4F1",
  // PRIORITY_BORDER: "#FFA48F",
};

export enum EventFlagCode {
  ACCEPTED = "ACCEPTED",
  DECLINED = "DECLINED",
  TENTATIVE = "TENTATIVE",
  NEEDSACTION = "NEEDSACTION",
  PRIORITY = "PRIORITY",
  OPTIONAL = "OPTIONAL",
}

export const EVENT_FLAG_COLORS = {
  ACCEPTED: "#32BD00",
  DECLINED: "#fa504b",
  TENTATIVE: "#4dbeed",
  NEEDSACTION: "#f0a93c",
  PRIORITY: "#FF2D00",
  OPTIONAL: "#EDAD4D"
};
